import React, { FC } from 'react';
// mui components
import { Grid, Typography } from '@mui/material';
// components
import Player from 'components/player';
// api
import { IPostUploads } from 'redux-store/api/activity-feed';
import { IUploadedFilesData } from 'redux-store/types';
// styles
import { styles } from './styles';

interface IProps {
  uploadedMultimedia: IUploadedFilesData[] | IPostUploads[];
}

const isUploadsFromPost = (data: any[]): data is IPostUploads[] => {
  return data?.some((item) => item.mimeType);
};

const Wrapper: FC = ({ children }) => {
  return <Grid sx={styles.wrapper}>{children}</Grid>;
};

const UploadedAudioContent: FC<IProps> = ({ uploadedMultimedia }) => {
  const audioContent = isUploadsFromPost(uploadedMultimedia)
    ? uploadedMultimedia.filter(({ mimeType }) => mimeType?.includes('audio'))
    : [];

  if (!audioContent.length) {
    return null;
  }

  return (
    <Grid sx={styles.itemsContainer}>
      {audioContent.map((audio) => (
        <Grid key={audio.id} sx={styles.container}>
          <Typography sx={styles.typo}>Audio Message</Typography>
          <Player controls={true} url={audio.url} wrapper={Wrapper} />
        </Grid>
      ))}
    </Grid>
  );
};

export default UploadedAudioContent;
